module.exports = __webpack_public_path__ + "img/merdeka-mengajar.8afa0b1d.png";